export const WEBSITE_SHOP_NAME = process.env.REACT_APP_SHOP_NAME;
export const WEBSITE_SHOP_HASH = process.env.REACT_APP_SHOP_HASH;
export const SNP_JUMPLED = process.env.REACT_APP_SNP_JUMPLED;
export const SNP_ENCODER = process.env.REACT_APP_SNP_ENCODER;

export const IS_DEV = process.env.REACT_APP_DEV === 'true';
export const BASE_TEST_URL = "http://localhost:8021/";
export const BASE_URL = process.env.REACT_APP_API_URL;
export const IMAGE_URL = `${BASE_URL}files/`;


export const INVALIDBILL = 101;
export const USEREXIST = 102;
export const SHOPEXIST = 103;
export const USEREXISTASEMP = 104;
export const INVALIDSMSOTP = 105;
export const INVALIDEMAILOTP = 106;
export const NOITEMSAVAILABLE = 110;
export const SUCCESS = 200;
export const UPDATEHOMEDELIVERY = 201;
export const ROLEUPDATE = 202;
export const ORDERRECEIVED = 203;
export const FAILED = 401;
export const NODATA = 402;
export const NULLDATA = 404;
export const ROLEERROR = 406;
export const ACCESSDENIED = 407;
export const SESSIONEXPIRED = 408;
export const FIELD_EMPTY = 409;
export const SHOPNOTACCESSERROR = 410;
export const VALIDITYEXPIREDERR = 411;
export const USERNOTFOUND = 415;
export const EMAILPASSWORDERROR = 416;
export const INTERNAL_ERROR = 500;

export const EMAIL_RE = /([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;

export const URL_RE =
	/\b((?:https?:\/\/|www\.)[^\s<>()]+(?:\.[^\s<>()]+)*[^\s<>().,;:"')\]])/gi;

export const LINK_RE = new RegExp(`${EMAIL_RE.source}|${URL_RE.source}`, "gi");

export const Server_Constants = {
	IN_WHISLIST: "in_whislist",
	IN_CART: "in_cart",
};

export const sortByPrice = [
	{ label: "High To Low", value: "desc" },
	{ label: "Low To High", value: "asc" },
	{ label: "Reset", value: "reset" },
];

export const ItemCondtion = [
	{ label: "New" },
	{ label: "Vintage" },
	{ label: "Pre-Owned" },
];

export const SizeType = {
	None: "NONE",
	Zero: "ZERO",
	XS: "XS",
	S: "S",
	M: "M",
	L: "L",
	XL: "XL",
	XXL: "XXL",
	XXXL: "XXXL"
};

export const CartOperation = {
	add: 1,
	remove: 2,
	permanent_remove: 3
};

//App social 
export const ONLINELISTOFFERDISPLAY = "Web Offer Display";
export const BILLICON = "Show Icon in Bill";


export const OfferType = {
	No_Offer: 1, Flat: 2, Percentage: 3, ONVALUE_FLAT: 4, ONVALUE_PERC: 5, Multi: 6
};


export const OrderStatusId = {
	INITIATED: "Initiated",
	FAILED: "Failed",
	REJECTED: "Rejected",
	PAID: "Paid",
	ASSIGNED: "Assigned",
	ON_THE_WAY: "On the Way",
	DELIVERED: "Delivered",
}

export const PAYMENT_GATEWAY_CLIENT = {
	RAZORPAY: "razorPayClient",
	CASHFREE: "cashfreeClient",
};

export const PersonType = {
	None: "NONE",
	Men: "MEN",
	Women: "WOMEN",
	Kids: "KIDS"
};
